import React, { createContext, useContext, useState, useEffect } from 'react';
import { LinkedBrand, hotelBrandAdminService } from '../services/hotelBrandAdminService';

interface BrandAdminContextType {
  linkedBrands: LinkedBrand[];
  selectedBrand: LinkedBrand | null;
  setSelectedBrand: (brand: LinkedBrand | null) => void;
  isLoading: boolean;
}

const BrandAdminContext = createContext<BrandAdminContextType | undefined>(
  undefined
);

export const BrandAdminProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [linkedBrands, setLinkedBrands] = useState<LinkedBrand[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<LinkedBrand | null>(null);
    const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLinkedBrands = async () => {
      setIsLoading(true);
      try {
          const brandsResponse = await hotelBrandAdminService.getLinkedBrands();
          const brands = brandsResponse?.data;
        if (brands && brands.length > 0) {
          setLinkedBrands(brands);
          setSelectedBrand(brands[0]); // Set first brand as default
        }
      } catch (error) {
        console.error('Error fetching linked brands:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLinkedBrands();
  }, []);

  const value: BrandAdminContextType = {
    linkedBrands,
    selectedBrand,
    setSelectedBrand,
    isLoading,
  };

  return (
    <BrandAdminContext.Provider value={value}>
      {children}
    </BrandAdminContext.Provider>
  );
};

export const useBrandAdmin = () => {
  const context = useContext(BrandAdminContext);
  if (context === undefined) {
    throw new Error('useBrandAdmin must be used within a BrandAdminProvider');
  }
  return context;
};
